import React from 'react'
import { AppBar, TextField, Button, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import Constants from './Constants'
export default function Login({ api }) {
    const [state, setState] = React.useState(0)
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [code, setCode] = React.useState('')
    return (
        <div style={{ backgroundColor: '#4aebc2', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ padding: 10, width: '81%', margin: 25, backgroundColor: '#fff', zIndex: 100 }}>

                <h2>chatHYPE</h2>
                <br />
                <Accordion expanded={state === 0} style={{ margin: 20 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                    >
                        Login
                        </AccordionSummary>
                    <AccordionDetails style={{ display: 'flex', flexDirection: 'column', padding: 7 }}>
                        <TextField required value={email} onChange={e => setEmail(e.target.value)} fullWidth label="Email" />
                        <br />
                        <Button disabled={email.trim().length === 0} onClick={e => {
                            api.axios.post(Constants.baseURL + "api/users/admin-validate-email", {
                                email
                            })
                                .then(d => {
                                    api.showSnack('Code sent to email', 'success');
                                    setState(1)
                                })
                                .catch(e => api.showSnack(e.error || 'Something went wrongg', 'error'))
                        }} color="primary" variant="outlined">Login</Button>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={state === 1} style={{ margin: 20 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                    >
                        Enter OTP from email
                        </AccordionSummary>
                    <AccordionDetails style={{ display: 'flex', flexDirection: 'column', padding: 7 }}>
                        <TextField value={code} onChange={e => setCode(e.target.value)} required fullWidth label="Enter OTP from email" />
                        <br />
                        <TextField required type="password" value={password} onChange={e => setPassword(e.target.value)} fullWidth label="Enter Password" />
                        <br />
                        <Button disabled={email.trim().length === 0 || code.trim().length === 0 || password.trim().length === 0} onClick={e => {
                            api.axios.post(Constants.baseURL + "api/users/admin-validate", {
                                email,
                                code,
                                password
                            })
                                .then(d => {
                                    localStorage.setItem("admintoken", JSON.stringify(d))
                                    window.location = "/dash"
                                })
                                .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))
                        }} color="primary" variant="outlined">Login</Button>
                    </AccordionDetails>
                </Accordion>
            </div>

        </div >
    )
}
